import "../landParcels.css";

function LandParcelsDetail({ parcels }) {
  if (!Array.isArray(parcels) || parcels.length === 0) return null;

  return (
    <section className="land-parcels-detail" aria-labelledby="land-parcels-detail-title">
      <div className="container">
        <header className="land-parcels-detail__head">
          <h2 id="land-parcels-detail-title" className="section-title">
            Кадастрові ділянки
          </h2>
        </header>
        <div className="land-parcels-detail__rows">
          {parcels.map((parcel, index) => (
            <article className="land-parcels-detail__row" key={parcel.id}>
              <h3>Кадастрова ділянка {index + 1}</h3>
              <dl className="land-parcels-detail__facts">
                <div className="land-parcels-detail__fact">
                  <dt>Кадастровий номер</dt>
                  <dd>{parcel.cadastral_number}</dd>
                </div>
                <div className="land-parcels-detail__fact">
                  <dt>Категорія цільового призначення</dt>
                  <dd>{parcel.purpose_category_label}</dd>
                </div>
                {parcel.area_sotky !== null
                && parcel.area_sotky !== undefined
                && parcel.area_sotky !== "" ? (
                  <div className="land-parcels-detail__fact">
                    <dt>Площа ділянки, сотки</dt>
                    <dd>{parcel.area_sotky}</dd>
                  </div>
                  ) : null}
                <div className="land-parcels-detail__fact">
                  <dt>Червоні лінії або обмеження</dt>
                  <dd>
                    {parcel.has_red_lines_or_restrictions ? "Так" : "Ні"}
                  </dd>
                </div>
              </dl>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LandParcelsDetail;
